<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { pdcList } from '../../service/getData'

export default {
  props: {
    val: '',
    stockroom_id: '',
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      }
    },
  },
  data() {
    return {
      selected: '',
      lists: [],
      loading: false,
    }
  },
  methods: {
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          query: query,
          stockroom_id: this.stockroom_id,
        }
        let res = await pdcList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>